export const colorsTheme = {
  white: '#FFFFFF',
  black: '#000000',
  danger: '#F2383A',

  'gradient-deg': '294deg',
  'gradient-primary': '#00AEEF',
  'gradient-secondary': '#00AEEF',

  'primary-color': '#00AEEF',
  'secondary-color': '#00AEEF',
  'auxiliary-color': '#00AEEF',

  'secondary-button-background': 'transparent',
  'secondary-button-background-hover': '#00AEEF',
  'secondary-button-color': '#00AEEF',
  'secondary-button-color-hover': '#FFFFFF',
  'secondary-button-border': '#00AEEF',
  'secondary-button-border-hover': '#00AEEF',

  'bg-color': '#FFFFFF',
  'bg-secondary-color': '#1A1A1A',
  'bg-auxiliary-color': '#EDEDED',

  'bg-circle-color': '#FFFFFF',
  'bg-circle-hover': '#C7DEFF',
  'bg-circle-text-color': '#000',
  'bg-circle-text-color-hover': '#FFFFFF',

  'filter-button-background': '#00AEEF',
  'filter-button-color': '#FFFFFF',
  'filter-button-border': '#00AEEF',
  'entry-message-color': '#00AEEF',

  'bg-modal-color': '#FFFFFF',

  'dark-color': '#3F3F3F',

  'text-primary': '#1E1E1E',
  'text-secondary': '#00AEEF;',
  'text-gray': '#4F4F4F',

  'input-color': '#1E1E1E',
  'bg-input-color': '#FFFFFF',
  'info-color': '#C7DEFF',
  'disabled-color': '#e2e2e2',
  'card-color': '#EEEEEE',
  'modal-border-color': '#ADB5BD',
  'border-color': '#00AEEF',

  'login-background': 'https://internet-banking-assets.s3.amazonaws.com/forpay/login-background.png',

  'echeck-label-color': '#000',
  'echeck-border-color': '#D2D2D2',
  'echeck-text-color': '#000',
  'echeck-bar-color1': '#00AEEF',
  'echeck-bar-color2': '#00AEEF'
};
